import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { ChangelogScene } from 'scenes';

class ChangelogContainer extends AbstractContainer {

  getTasks() {

    return [
      {
        group: 1,
        key: 'entries',
        exec: (done, failure) => {
          API.get('changelogs')
          .then((response) => {
            done(response.data);
          })
          .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <ChangelogScene entries={results.entries} />
  }
}

export default ChangelogContainer;
